import {z} from 'zod';

export const discountSchema=z.object({mode:z.enum(['percent','amount']),value:z.string().regex(/^\d{1,12}(\.\d{1,4})?$/,'Use a non-negative decimal with up to four places.')}).strict();
export type Discount=z.infer<typeof discountSchema>;
export const roundingSchema=z.object({increment:z.enum(['none','0.05','1']),accountId:z.string().max(100)}).strict();
export const adjustmentsSchema=z.object({discount:discountSchema.optional(),rounding:roundingSchema.optional()}).strict();
export type DocumentAdjustments=z.infer<typeof adjustmentsSchema>;
